import { observable, action } from 'mobx';
import ApiCaller from '../../utils/api-caller';
import LocalStorage from '../../utils/localStorage';

const laundryPendingOrderKey = 'Pending_Laundry_';

class laundryStore {

    // Main Properties

    @observable menu = null;
    @observable laundryItems = [];
    @observable laundryFilterItems = [];
    @observable laundryPendingOrders = [];
    @observable laundryRemark = '';
    @observable laundrySearchText = '';
    @observable laundrySearchSubCategory = 'All';
    @observable laundryTotalOrder = 0;

    // Laundry Detail Modal

    @observable laundryDetail = null;
    @observable showLaundryDetailModal = false;

    // Laundry Tab

    @observable laundryTabLoading = false;
    @observable laundryTabCategories = [];
    @observable laundryTabSubCategories = [];
    @observable laundryTabCategoryIdActive = '0';

    // Laundry Confirm

    @observable laundrySubTotal = 0;
    @observable laundryVat = 0;
    @observable laundryVatTax = 0;
    @observable laundryServiceFee = 0;
    @observable laundryServiceFeeTax = 0;
    @observable laundryTotal = 0;

    @observable laundryTimeSelected = 'now';
    @observable laundryTimeDeliver = '';
    @observable laundryTimeDeliverDate = '';

    @observable laundryPaymentOption = 'Cash';

    // Swipe
    @observable swipeX = 0;
    @observable isSwipe = false;

    // Initialization

    @action initGetLaundries(roomNo) {
        const that = this;

        const languageCode = window.localStorage.getItem('lang') || 'en';
        return ApiCaller.CmsTasks.getLaundries(languageCode).then((laundryResponses) => {
            if (laundryResponses) {
                that.menu = laundryResponses.menu;
                that.laundryTabCategories = laundryResponses.categoryNames;
                that.laundryTabSubCategories = that.laundryTabCategories[0].subCategories;

                if (that.laundryTabCategoryIdActive === '0') {
                    that.laundryTabCategoryIdActive = that.laundryTabCategories[0].taskId.toString();
                }

                that.laundryItems = laundryResponses.items;
                that.laundryFilterItems = that.laundryItems;

                if (that.laundryFilterItems.length > 0) {
                    that.laundryFilterItems.map((laundryItem) => {
                        return laundryItem.orderQuantity = 0;
                    });

                    const laundryOrders = this.getLaundryPendingOrdersFromStorage(roomNo);
                    if (laundryOrders !== null) {
                        laundryOrders.map((laundryOrder) => {
                            let laundryItem = that.laundryFilterItems.find(it => it.taskId === laundryOrder.taskId);
                            if (laundryItem) {
                                laundryItem.orderQuantity = laundryOrder.orderQuantity;
                            }
                            return laundryItem;
                        })
                    }
                }
            } else {
                that.menu = null;
                that.laundryTabCategories = [];
                that.laundryTabSubCategories = [];
                that.laundryItems = [];
                that.laundryFilterItems = [];
                that.laundrySearchText = '';
                that.laundrySearchSubCategory = 'All';
            }

            this.searchLaundryByNameAndSubCategory();
        });
    }

    @action refreshLaundries(roomNo) {
        const that = this;

        const languageCode = window.localStorage.getItem('lang') || 'en';
        return ApiCaller.CmsTasks.getLaundries(languageCode).then((laundryResponses) => {
            if (laundryResponses) {
                that.menu = laundryResponses.menu;
                that.laundryTabCategories = laundryResponses.categoryNames;
                that.laundryTabSubCategories = that.laundryTabCategories[0].subCategories;

                if (that.laundryTabCategoryIdActive === '0') {
                    that.laundryTabCategoryIdActive = that.laundryTabCategories[0].taskId.toString();
                }

                that.laundryItems = laundryResponses.items;
                that.laundryFilterItems = that.laundryItems;

                if (that.laundryFilterItems.length > 0) {
                    that.laundryFilterItems.map((laundryItem) => {
                        return laundryItem.orderQuantity = 0;
                    });

                    const laundryOrders = this.getLaundryPendingOrdersFromStorage(roomNo);
                    if (laundryOrders !== null) {
                        laundryOrders.map((laundryOrder) => {
                            let laundryItem = that.laundryFilterItems.find(it => it.taskId === laundryOrder.taskId);
                            if (laundryItem) {
                                laundryItem.orderQuantity = laundryOrder.orderQuantity;
                            }
                            return laundryItem;
                        })
                    }
                }
            } else {
                that.menu = null;
                that.laundryTabCategories = [];
                that.laundryTabSubCategories = [];
                that.laundryItems = [];
                that.laundryFilterItems = [];
                that.laundrySearchText = '';
                that.laundrySearchSubCategory = 'All';
            }

            this.searchLaundryByNameAndSubCategory();
        });
    }

    @action initLaundryConfirm(roomNo) {
        this.laundryRemark = '';
        this.laundryTimeSelected = 'now';
        this.laundryTimeDeliver = '';

        let data = LocalStorage.Get(laundryPendingOrderKey + roomNo);
        if (data !== null) {
            this.laundryPendingOrders = data;
        }

        const languageCode = window.localStorage.getItem('lang') || 'en';
        return ApiCaller.CmsTasks.getLaundry(languageCode).then(resp => {
            this.menu = resp;

            this.laundryVatTax = resp.vat;
            this.laundryServiceFeeTax = resp.serviceFee;

            this.setLaundryPriceDetail();
        });
    }

    @action initTotalLaundryOrder(roomNo) {
        const orders = LocalStorage.Get(laundryPendingOrderKey + roomNo);

        if (orders) {
            let quantity = 0;
            orders.map(order => {
                quantity = quantity + order.orderQuantity;

                return order;
            });

            this.laundryTotalOrder = quantity;
        } else {
            this.laundryTotalOrder = 0;
        }
    }

    // Transaction Action

    @action goToLaundryConfirmPage(roomNo) {
        let items = this.laundryItems.filter(item => item.orderQuantity > 0);
        LocalStorage.Save(laundryPendingOrderKey + roomNo, items);
        return LocalStorage.Get(laundryPendingOrderKey + roomNo);
    }

    @action goToLaundryConfirmPageFromRetailOffer(roomNo, taskId) {
        return this.refreshLaundries(roomNo).then(() => {
            let item = this.laundryItems.find(item => item.taskId === taskId);
            item.orderQuantity = item.orderQuantity + 1;
            let items = this.laundryItems.filter(item => item.orderQuantity > 0);
            LocalStorage.Save(laundryPendingOrderKey + roomNo, items);
            LocalStorage.Get(laundryPendingOrderKey + roomNo);
        });
    }

    @action removeLaundryOrders(roomNo) {
        this.laundryItems = [];
        this.laundryFilterItems = this.laundryItems;
        LocalStorage.Remove(laundryPendingOrderKey + roomNo);
    }

    @action backToLaundryMainPage(roomNo) {
        const laundryPendingOrders = this.laundryPendingOrders.filter(item => item.orderQuantity > 0);

        if (laundryPendingOrders) {
            LocalStorage.Save(laundryPendingOrderKey + roomNo, laundryPendingOrders);
        } else {
            LocalStorage.Save(laundryPendingOrderKey + roomNo, []);
        }
    }

    // GET Properties

    @action getLaundriesByTaskId(taskId) {
        const laundryItem = this.laundryItems.find(it => it.taskId === taskId);

        this.laundryDetail = laundryItem;
        this.showLaundryDetailModal = true;

        return laundryItem;
    }

    @action getLaundryPendingOrders() {
        return this.laundryPendingOrders.filter(it => it.orderQuantity > 0);
    }

    @action getLaundryPendingOrdersFromStorage(roomNo) {
        return LocalStorage.Get(laundryPendingOrderKey + roomNo);
    }

    // Set Properties

    @action setLaundryRemark(value) {
        this.laundryRemark = value;
    }

    @action setLaundryItemQty(taskId, value) {
        const laundryItem = this.laundryItems.find(it => it.taskId === taskId);
        laundryItem.orderQuantity = value;

        let quantity = 0;

        this.laundryItems.map(item => {
            quantity = quantity + item.orderQuantity;
            return item;
        });

        this.laundryTotalOrder = quantity;
    }

    @action setLaundryPendingOrderQty(taskId, value) {
        const laundryPendingOrder = this.laundryPendingOrders.find(it => it.taskId === taskId);
        laundryPendingOrder.orderQuantity = value;

        this.setLaundryPriceDetail();
    }

    @action setShowLaundryDetailModal(value) {
        this.showLaundryDetailModal = value;
    }

    @action setLaundryPriceDetail() {
        this.laundrySubTotal = 0;

        this.laundryPendingOrders.map((order) => {
            if (order.price === order.specialPrice) {
                this.laundrySubTotal = this.laundrySubTotal + (order.orderQuantity * order.price);
            } else {
                this.laundrySubTotal = this.laundrySubTotal + (order.orderQuantity * order.specialPrice);
            }

            return this.laundrySubTotal;
        });

        this.laundryServiceFee = this.laundrySubTotal * this.laundryServiceFeeTax / 100;
        this.laundryVat = (this.laundrySubTotal + this.laundryServiceFee) * this.laundryVatTax / 100;
        this.laundryTotal = this.laundryVat + this.laundryServiceFee + this.laundrySubTotal;
    }

    @action setLaundryTimeSelected(value) {
        this.laundryTimeSelected = value;
        this.laundryTimeDeliver = '';
    }

    @action setLaundryTimeDeliver(value) {
        this.laundryTimeDeliver = value;
        this.laundryTimeSelected = '';
    }

    @action setLaundryTimeDeliverDate(value) {
        this.laundryTimeDeliverDate = value;
    }

    @action searchLaundryByNameAndSubCategory() {
        if (this.laundrySearchText === '' && this.laundrySearchSubCategory === 'All') {
            this.laundryFilterItems = this.laundryItems;
            return;
        }

        if (this.laundrySearchSubCategory === 'All') {
            this.laundryFilterItems = this.laundryItems;
        } else {
            this.laundryFilterItems = this.laundryItems.filter(item => {
                let subCategoryName = item.subCategoryName.toLowerCase();
                return subCategoryName.indexOf(this.laundrySearchSubCategory.toLowerCase()) !== -1;
            });
        }

        if (this.laundrySearchText !== '') {
            this.laundryFilterItems = this.laundryFilterItems.filter(item => {
                let itemTaskName = item.taskName.toLowerCase();
                return itemTaskName.indexOf(this.laundrySearchText.toLowerCase()) !== -1;
            });
        }
    }

    @action setLaundrySearchText(value) {
        this.laundrySearchText = value;
    }

    @action setLaundrySearchSubCategory(value) {
        this.laundrySearchSubCategory = value;
    }

    @action setLaundryTabSubCategoriesByTabCategoryTaskId(tabCategoryTaskId) {
        this.laundryTabCategoryIdActive = tabCategoryTaskId.toString();
        const category = this.laundryTabCategories.find(fi => fi.taskId === parseInt(tabCategoryTaskId));

        if (category) {
            if (category.subCategories.length > 0) {
                this.laundryTabSubCategories = category.subCategories;
                return;
            }
        }

        this.laundryTabSubCategories = [];
    }

    @action setLaundryPaymentOption(value) {
        this.laundryPaymentOption = value;
    }

    @action setSwipeX(value) {
        this.swipeX = value;
    }

    @action setIsSwipe(value) {
        this.isSwipe = value;
    }

    // RESET Properties

    @action resetData() {
        this.menu = null;
        this.showLaundryDetailModal = false;
        this.laundryTabCategories = [];
        this.laundryTabSubCategories = [];
        this.laundryItems = [];
        this.laundryFilterItems = [];
        this.laundrySearchText = '';
        this.laundrySearchSubCategory = 'All';
        this.searchLaundryByNameAndSubCategory();
    }
}

export default new laundryStore()